<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";
import p from "@/http/pouch/index.js";

import pouch from "@/db/pouch.js";

export default {
  data() {
    return {
      ps: null,
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  async mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // let o = {
    //   _id: "This will be public",
    //   d:
    //     "Hello i am a long string which should not be read by anyone but my owner but i am being transferred online",
    // };
    // await pouch.en(o).then(async (d) => {
    //   console.log("Object", o);
    //   console.log("Encrypted", d);
    //   await pouch.de(d).then((u) => {
    //     console.log("Decrypted", u);
    //   });
    // });

    // var no = [
    //   {
    //     _id: "some string",
    //     d:
    //       "Hello i am a long string which should not be read by anyone but my owner but i am being transferred online",
    //   },
    //   {
    //     _id: "Some other string",
    //     d:
    //       "Hello i am a long string which should not be read by anyone but my owner but i am being transferred online",
    //   },
    // ];
    // console.log("before", no);
    // await pouch.en(no).then(async (d) => {
    //   console.log("Encrypted", d);
    //   await pouch.de(d).then((u) => {
    //     console.log("Decrypted", u);
    //   });
    // });
  },
  async created() {
    this.ps = p.init(this.$pouch);

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    this.$acl.change(
      this.$session.get("user") ? this.$session.get("user").e : "public"
    );
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
